<sm-title-bar pageTitle="{{ 'change_phone.title' | translate }}" > </sm-title-bar>

<div class="merchant_detail_sec" >
  <div class="mrt_offe">
    <div class="row">
   
      <div class="col-sm-8">
        <div class="drt_head">
        </div>
        <div class="list_user" *ngIf="loader == false">
          <a href="javascript:void(0)" class="admin_category">
            <div class="card_header chead">
              <div class="adm_set">

                <div class="progress-bar">
                  <div class="progress-circle active bhy_md">
                    <div class="progress-circle-dot-container">
                      <div class="progress-circle-dot"></div>
                    </div>
                  </div>
                  <div class="progress-circle active bhy_sd">
                    <div class="progress-circle-dot-container">
                      <div class="progress-circle-dot"></div>
                    </div>
                  </div>
                  <div id="progress-line" class="progress-line"></div>
                </div>
            
                <div>
                  <div class="pgk_sectionm">
                  <span class="name_cont">{{ 'change_phone.h1' | translate }}</span>
                </div>
                  <h2 style="margin-top: 0px;
                  color: #212121;
                  margin-bottom: 0px;
                  font-size: 16px;
                  font-weight: bold;">{{ 'change_phone.s1' | translate }}</h2>
                  <h4 class="cer_heaidng">{{ 'change_phone.s1_txt' | translate }}</h4>
                  <h2 style="margin-top: 0px;
                  color: #212121;
                  margin-bottom: 0px;
                  font-size: 16px;
                  font-weight: bold;">{{ 'change_phone.s2' | translate }}</h2>
                  <h4 class="cer_heaidng">{{ 'change_phone.s2_txt' | translate }}</h4>
                </div>


              </div>
            </div>
          </a>
        </div>


        <!-- section end -->
        <div class="phone_chnage_sectionm">
          <mat-card>
            <form>
            
              <div class="g-2 mb-3 justify-content-between phone-field">
                <div class="phone_chnage_tt">
                <mat-form-field appearance="outline" class="col-3">
                  <mat-label>Country</mat-label>
                  <mat-select required >
                    <mat-select-trigger>
                     +91
                    </mat-select-trigger>
                      <input
                      style="width: 80%;
                      height: 25px;
                      padding: 10px;
                      border: 1px solid lightgray;
                      margin: 10px;
                      border-radius: 5px;
                  "     matInput
                        placeholder="Enter country name"
                      />
                    <mat-option>India</mat-option>
                  </mat-select>
                </mat-form-field>
                <mat-form-field appearance="outline" class="col-9">
                  <mat-label>New phone number</mat-label>
                  <input
                    matInput
                    type="tel"
                    maxlength="10"
                    required
                    placeholder="Enter new phone number"
                  />
                  <button style="position: relative;
                  top: -6px;"
                    type="button"
                    mat-button
                    matSuffix
                    color="primary"
                  >
                    Send OTP
                  </button>
                  <mat-error>Invalid phone number!</mat-error>
                  <mat-hint>Enter 10 digit phone number</mat-hint>
                </mat-form-field>
              </div>
            </div>
              <!-- <div class="mb-3">
                <mat-form-field appearance="outline" class="w-100">
                  <mat-label>Enter OTP</mat-label>
                  <input
                    matInput
                    type="text"
                    maxlength="6"
                    required
                  />
                  <mat-error>Invalid OTP</mat-error>
                </mat-form-field>
              </div> -->
      
              <button
                mat-flat-button
                color="accent"
                class="w-100"
             
                #submitButton
              >
                Confirm
              </button>
            </form>
          </mat-card>
        </div>
        <!--  -->
       
      </div>
      <div class="col-md-4 booking-sidebar">
        <mat-card class="collapsible-container">
          <div class="collapsible-container">
            <div class="collapsible-header" (click)="toggle()">
              <h4>What are the benefits salon?</h4>
              <mat-icon class="arrow-icon">{{ isOpen ? 'keyboard_arrow_up' : 'keyboard_arrow_down' }}</mat-icon>
            </div>
            <div class="collapsible-body" [ngClass]="{ 'open': isOpen, 'closed': !isOpen }">
              <p>We are always open to partnerships with brands and merchants that align with our values. If you're interested in collaborating, please fill out our Partnership Inquiry Form, and our team will get back to you with more details.</p>
            </div>
          </div>
          <!--  -->
          <div class="collapsible-container">
            <div class="collapsible-header" (click)="toggle()">
              <h4>What are the benefits of partnering  salon?</h4>
              <mat-icon class="arrow-icon">{{ isOpen ? 'keyboard_arrow_up' : 'keyboard_arrow_down' }}</mat-icon>
            </div>
            <div class="collapsible-body" [ngClass]="{ 'open': isOpen, 'closed': !isOpen }">
              <p>We are always open to partnerships with brands and merchants that align with our values. If you're interested in collaborating, please fill out our Partnership Inquiry Form, and our team will get back to you with more details.</p>
            </div>
          </div>
             <!--  -->
             <div class="collapsible-container">
              <div class="collapsible-header" (click)="toggle()">
                <h4>Is there a cost associated with partner?</h4>
                <mat-icon class="arrow-icon">{{ isOpen ? 'keyboard_arrow_up' : 'keyboard_arrow_down' }}</mat-icon>
              </div>
              <div class="collapsible-body" [ngClass]="{ 'open': isOpen, 'closed': !isOpen }">
                <p>We are always open to partnerships with brands and merchants that align with our values. If you're interested in collaborating, please fill out our Partnership Inquiry Form, and our team will get back to you with more details.</p>
              </div>
            </div>
               <!--  -->
          <div class="collapsible-container">
            <div class="collapsible-header" (click)="toggle()">
              <h4>Can I host an event at your salon?</h4>
              <mat-icon class="arrow-icon">{{ isOpen ? 'keyboard_arrow_up' : 'keyboard_arrow_down' }}</mat-icon>
            </div>
            <div class="collapsible-body" [ngClass]="{ 'open': isOpen, 'closed': !isOpen }">
              <p>We are always open to partnerships with brands and merchants that align with our values. If you're interested in collaborating, please fill out our Partnership Inquiry Form, and our team will get back to you with more details.</p>
            </div>
          </div>
          
                <!--  -->
                <div class="collapsible-container">
                  <div class="collapsible-header" (click)="toggle()">
                    <h4>What are the benefits  salon?</h4>
                    <mat-icon class="arrow-icon">{{ isOpen ? 'keyboard_arrow_up' : 'keyboard_arrow_down' }}</mat-icon>
                  </div>
                  <div class="collapsible-body" [ngClass]="{ 'open': isOpen, 'closed': !isOpen }">
                    <p>We are always open to partnerships with brands and merchants that align with our values. If you're interested in collaborating, please fill out our Partnership Inquiry Form, and our team will get back to you with more details.</p>
                  </div>
                </div>
          
        </mat-card>
        
       
        
      </div>
      <!-- <div class="col-sm-1"></div> -->
    </div>
  </div>
</div>
